import useSWR, { mutate as globalMutate } from "swr";
import axios from "axios";
import { DOMAIN_API_HOST } from '../configs/main.js';

export const AGENCY_ME_KEY = `agency_${DOMAIN_API_HOST}/api/v1/me`;

export async function fetchAgencyUser() {
  const token = localStorage.getItem("agency_token");
  if (!token) {
    throw new Error("No agency token");
  }
  const response = await axios.get(`${DOMAIN_API_HOST}/api/v1/me`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}

export function setAgencyUserCache(user) {
  return globalMutate(AGENCY_ME_KEY, user, false);
}

export default function useAgencyUser() {
  const token = typeof window !== "undefined" ? localStorage.getItem("agency_token") : null;

  const { data, error, mutate } = useSWR(token ? AGENCY_ME_KEY : null, fetchAgencyUser);
  const isLoading = token ? (!error && !data) : false;
  const loggedOut = Boolean(!isLoading && error);
  const role = data?.role;

  return {
    token,
    user: data,
    isLoading,
    loggedOut,
    role,
    mutate,
  };
}
